import { Injectable } from '@angular/core';
import { IDBPDatabase, openDB } from 'idb';
import { FileMetadata } from '../../models/file-metadata.model';

export type CachedExcelFile = {
  data: ArrayBuffer;
  metadata: FileMetadata;
  updatedAt: number;
};

const DB_NAME = 'excel-cache';
const DB_VERSION = 2;
const STORE_NAME = 'files';

@Injectable({
  providedIn: 'root',
})
export class ExcelCacheService {
  private dbPromise: Promise<IDBPDatabase>;

  constructor() {
    this.dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      },
    });
  }

  async get(fileId: string): Promise<CachedExcelFile | undefined> {
    const db = await this.dbPromise;
    return db.get(STORE_NAME, fileId);
  }

  async set(
    fileId: string,
    metadata: FileMetadata,
    data: ArrayBuffer
  ): Promise<void> {
    const db = await this.dbPromise;
    await db.put(
      STORE_NAME,
      { data, metadata, updatedAt: Date.now() } satisfies CachedExcelFile,
      fileId
    );
  }

  async remove(fileId: string): Promise<void> {
    const db = await this.dbPromise;
    await db.delete(STORE_NAME, fileId);
  }
}
